import { render, staticRenderFns } from "./PartnerMain.vue?vue&type=template&id=786d07d5&"
import script from "./PartnerMain.vue?vue&type=script&lang=js&"
export * from "./PartnerMain.vue?vue&type=script&lang=js&"
import style0 from "./PartnerMain.vue?vue&type=style&index=0&id=786d07d5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports